import crypto from "crypto";
const algorithm = "aes-256-cbc";

export const encryption = (secretKey, text) => {
  const iv = crypto.randomBytes(16).toString("hex").slice(0, 16);
  const decodeKey = crypto.createHash("sha256").update(secretKey, "utf8").digest();
  const cipher = crypto.createCipheriv(algorithm, decodeKey, iv);
  const encrypted = cipher.update(text, "utf8", "hex") + cipher.final("hex");
  return {
    iv: iv,
    content: encrypted,
  };
};

export const decryption = (secretKey, hash) => {
  const encodeKey = crypto.createHash("sha256").update(secretKey, "utf8").digest();
  const decipher = crypto.createDecipheriv(algorithm, encodeKey, hash.iv);
  const decrypted = decipher.update(hash.content, "hex", "utf8") + decipher.final("utf8");
  return decrypted.toString();
};
